import { Component } from '@angular/core';
import { MaliciousComponent } from 'app/components/malware/malicious/malicious.component';
import { BackupSystemsService } from 'app/services/backup-systems';
import { MaliciousFileStatus } from '@imunify360-api/malicious';

/**
 * If there will be second type of group actions, then:
 * 1. Implement actions as parameters
 * or
 * 2. Implement dynamic grouping action to group actions
 */
@Component({
    template: `
        <i360-action
                title="actions.other"
                i360-group-actions
                [filter]="{status: status}">
            <cl-add-to-ignore-malicious-action></cl-add-to-ignore-malicious-action>
            <i360-restore-from-backup-malicious-action></i360-restore-from-backup-malicious-action>
            <i360-restore-from-quarantine-malicious-action>
            </i360-restore-from-quarantine-malicious-action>
        </i360-action>
    `,
})
export class GroupActionsComponent {
    status = [
        MaliciousFileStatus.quarantined,
        MaliciousFileStatus.found,
    ];

    constructor(public malicious: MaliciousComponent,
                public backupSystemsService: BackupSystemsService) {
    }
}
